import { render, staticRenderFns } from "./HazardListPrint.vue?vue&type=template&id=ab8fc8ac"
import script from "./HazardListPrint.vue?vue&type=script&lang=ts"
export * from "./HazardListPrint.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports